<template>
  <div>
    <leftSideBar :anchor="anchor"></leftSideBar>
    <SideBar></SideBar>
    <div class="page-box">
      <div class="secure-block">
        <h3 class="rescue-bigtitle"
            id="one">辅助生殖IVF，助孕新希望</h3>
        <h4 class="rescue-title"
            style="margin-bottom:27px">什么是IVF？</h4>
        <div class="container-img-text">
          <p class="secure-note">
            IVF是指试管婴儿，也称为体外受精-胚胎移植，也就是在体外使男性和女性的精子和卵子受精并结合，经过一段时间的培养，受精卵发育成早期胚胎，再植入到女性子宫中进行发育、分娩。
            <br/>
            试管婴儿分为第一代、第二代和第三代。第二代试管婴儿是一种卵细胞单精子显微注射技术，主要针对男性不育，第三代试管婴儿通常针对那些希望筛查遗传或染色体疾病的人士。
          </p>
          <img src="../assets/images/medicine/img2.png"
               alt="">
        </div>
        <h4 class="rescue-title" id="gxpgn">为什么选择日本IVF？</h4>
        <div class="container-img-text">
          <p class="secure-note">
            · 从促排到移植，提供适合患者身体状况的个性化治疗方案；<br/>
            · 对于40岁以上的高龄备孕群体，有丰富的妊娠案例经验；<br/>
            · 拥有先端检测、培养等设备和技术，二代、三代均可实施；<br/>
            · 环境好、注重私密性，医护团队态度亲切，减少就医压力。
          </p>
          <img src="../assets/images/medicine/img1.png"
               alt="">
        </div>

        <h4 class="rescue-title" id="gxplf">特色1：个体化促排方案</h4>
        <div class="container-img-text">
          <p class="secure-note content_class">
            综合考虑患者年龄、卵巢状况等因素，提供低刺激、中刺激、高刺激等适合患者的定制促排方案。在获取尽可能多的高质量优势卵子的同时，也尽力减少对患者的身体伤害。</p>
          <img src="../assets/images/medicine/img.png"
               alt="">
        </div>

        <h4 class="rescue-title" id="two">特色2：PGT-A检测·PGT-SR检测·PGT-M检测</h4>
        <div class="secure-reason">
          <img src="../assets/images/medicine/pgtajc.png"
               style="width:928px;margin-bottom:100px"
               alt="">
        </div>

        <h4 class="rescue-title"
            id="three"
            style="margin-bottom:10px;">特色3：个体化受精方法——IVF、Piezo-ICSI、Split</h4>
        <div class="container-img-text">
          <img src="../assets/images/medicine/gxhsjyy.png"
               alt="" style="height: 275px;width: 591px;">
          <img src="../assets/images/medicine/gthsjyy.png"
               alt="">
        </div>

        <h4 class="rescue-title" id="yzf">特色4：SEET（薄膜）移植法——提高着床率</h4>
        <h5 style="background: #e9ebf4;padding: 10px;font-size: 18px;line-height: 36px;">
          · SEET移植法（子宮内膜刺激胚移植）<br/>
          在胚胎移植前将胚胎培养液注入子宫内，刺激子宫内膜，促使子宫内膜开始准备受精卵着床的环境。这种在移植前注入胚胎培养液的方法就是 SEET移植法。
        </h5>
        <img src="../assets/images/medicine/qzqzt.png"
             style="margin-bottom: 70px;width: 100%"
             alt="">
        <!--        <div class="secure-reason">-->
        <!--          <img src="../assets/images/medicine/qzqzt.png"-->
        <!--               style="margin-bottom: 70px;"-->
        <!--               alt="">-->
        <!--        </div>-->

        <h4 class="rescue-title" id="tmxjz">特色5：透明质酸筛选精子（PICSI）</h4>
        <p style="font-size: 16px;color: #000;width: 100%;line-height: 32px;">
          显微受精（ICSI）挑选精子时，常用的方法是运用形态学筛选，技术熟练的培养师在显微镜下评估精子的形态和活力，筛选出形态和活力正常的精子。然而也有报告显示，形态上最好看的精子不一定是良好的精子。此外，ICSI省略了在体内和体外受精过程中自然筛选成熟精子的过程。因此，如果仅通过形态学筛选精子进行
          ICSI，有把未成熟的精子注射到卵子内的风险，结果会导致受精率和胚胎发育率下降和流产率增加。
        </p>
        <p style="font-size: 16px;color: #000;width: 100%;line-height: 32px;margin-bottom: 70px;">
          最理想的是，把完全发育成熟的精子注射到卵子内。通过研究发现，发育成熟的精子有高密度透明质酸受体，并能够与透明带和透明质酸相结合。使用透明质酸进行精子筛选很简单，不需要特殊设备和染色，分选出的精子可立即使用。换句话说，PICSI比传统的ICSI更有优势，因为它不仅可以对精子进行形态学评估，还可以确认其成熟度。
        </p>

        <h4 class="rescue-title" id="tmdhs">特色6：辅助孵化——透明带激光打孔术帮助细胞孵化</h4>
        <p style="font-size: 16px;color: #000;width: 100%;line-height: 32px;">
          卵子和受精卵在受精和发育阶段被透明带保护着。当胚胎发育到囊胚，在着床前会脱离透明带（孵化），植入子宫内膜（着床）。
        </p>
        <p style="font-size: 16px;color: #000;width: 100%;line-height: 32px;margin-bottom: 70px;">
          辅助孵化是指为了使胚胎更容易着床，切薄和打孔局部透明带，协助胚胎（受精卵）脱离透明带的方法。也有通过药物或者更直接的方法切开或切薄透明带的方法，但是透明带激光打孔术来辅助孵化更为安全。
        </p>

        <h4 class="rescue-title" id="grysbh">个人隐私保护</h4>
        <p style="font-size: 16px;color: #000;width: 100%;line-height: 32px;margin-bottom: 70px;">
          对于患者的姓名、出生日期、病历等个人信息，将依照院内的个人信息保护规程加以严格保管，如在病历研讨会或学会等使用本疗法中的信息，一定会采取匿名化措施（如使用培养ID等），不公开患者的任何个人信息。
        </p>

<!--        <h4 class="rescue-title" id="four">干细胞适合的人群</h4>
        <ul class="group-list"
            style="margin-bottom:100px;">
          <li>脑梗塞</li>
          <li>更年期障碍</li>
          <li>肝硬化</li>
          <li>阿尔兹海默症</li>
          <li>特应性皮炎</li>
          <li>肝功能不全</li>
          <li>帕金森病</li>
          <li>心肌梗塞</li>
          <li>关节痛</li>
          <li>ALS</li>
          <li>糖尿病</li>
          <li>腱损伤</li>
          <li>脊髓损伤</li>
          <li>高血压</li>
          <li>美容（改善肤质）</li>
          <li>肺气肿</li>
          <li>脱发</li>
        </ul>

        <h4 class="rescue-title" id="grysbh">个人隐私保护</h4>
        <p class="secure-note"
           style="width:auto;">
          对于患者的姓名、出生年月日、病历等个人信息，将依照院内的个人信息保护规程加以严格保管，如在病历研讨会或学会等使用本疗法中的信息，一定会采取匿名化措施（如使用培养ID等），不公开患者的任何个人信息。</p>
        <p class="secure-note"
           style="width:auto; margin-bottom:100px;">另外，对于所保管的干细胞中包含的最大个人信息——个人遗传基因信息，在没有得到患者同意的情况下绝对不会用于治疗以外的其他用途。</p>
        <h4 class="rescue-title" id="zysx">注意事项</h4>
        <p class="secure-note"
           style="width:auto;">
          对初次接受干细胞疗法的客人抽取的血液进行血液、生化学检查和病毒、细菌检查。如果此检查结果中发现患者受到某种病原体的感染，或者脂肪采集前规定的检查结果没有齐全，会针对提取的干细胞进行专门的感染症培养，并在培养过程中对细胞进行高感度的病毒基因检查，如果发现培养细胞也受到病毒感染，就无法实施回输，对此负责医生会做详细说明。</p>
        <p class="secure-note"
           style="width:auto; margin-bottom: 100px;">※感染症专门培养需要另外收取费用，并且需要对培养的细胞进行病毒基因检查，所以整个培养期比一般培养期长2周左右。</p>-->
        <h4 class="rescue-title" id="six">咨询流程</h4>
        <div class="secure-reason"
             style="margin-bottom:0">
          <img :src="reason6"
               alt=""
              style="width: 829px;">
        </div>
      </div>

      <div class="main"
           style="width:980px;">

        <h5 class="secure-title title01"
            id="five">合作医院
          <router-link to="/hospitalList/ksl/0"
                       class="ccc"
                       target="_blank">更多 &gt;
          </router-link>
        </h5>
        <div class="secure-hospital">
          <router-link v-for="(hos, index) in hospitals"
                       :to="'/hospitalInfo/' + hos.id"
                       target="_blank"
                       :key="index">
            <img class="hospital-img"
                 :src="baseURL + hos.hospital_img"
                 alt="">
            <div class="hospital-content">
              <h6 class="hospital-name"
                  v-html="hos.name"></h6>
              <p class="hospital-info">{{ hos.easy_brief }}</p>
            </div>
          </router-link>
        </div>
        <h5 class="secure-title title02"
            id="cases"
            style="padding-top:70px;">服务案例
          <router-link to="/successCase/4"
                       class="ccc"
                       target="_blank">更多 &gt;
          </router-link>
        </h5>
        <div class="fw-bg">
          <div class="medicine-case"
               v-for="(c,index) in cases"
               :key="index">
            <router-link target="_blank" :to="{name: 'successCaseDetail',params:{ id: c.id} }">
              <div class="case-info">
                <h5 class="case-info_text">{{ c.title }}</h5>
                <p class="case-ill">
                  <span>疾病：{{ c.disease_name }} </span>
                  <span class="b">{{ c.alias }}<br/> {{ c.age }} 岁</span>
                </p>
                <!-- <p class="case-topic">摘要： {{c.desc}}</p> -->
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import reason1 from "@/assets/images/medicine/reason11.jpg"
import reason2 from "@/assets/images/medicine/reason12.png"

import reason5 from "@/assets/images/medicine/reason18.png"
import reason6 from "@/assets/images/medicine/reason19.png"
import map from "@/assets/images/home/icon-link1.png"
import leftSideBar from "@/components/LeftSideTitleBar.vue"
import SideBar from "@/components/SideBar"
import * as apis from '@/api/hospital'
import * as cases from '@/api/success'
import {baseURL} from "@/api/axios"

export default {
  data() {
    return {
      baseURL,
      reason1,
      reason2,
      // reason3,
      // reason4,
      reason5,
      reason6,
      map,
      countries: [],
      cases: [],
      hospitals: [],
      anchor: [
        {title: '什么是IVF', id: 'one'},
        {title: '为什么选择日本IVF', id: 'gxpgn'},
        {title: '个体化促排方案', id: 'gxplf'},
        {title: '胚胎移植前检测', id: 'two'},
        {title: '个体化受精方法', id: 'three'},
        {title: 'SEET移植法', id: 'yzf'},
        {title: '透明质酸筛选精子', id: 'tmxjz'},
        {title: '透明带激光打孔术', id: 'tmdhs'},
        {title: '个人隐私保护', id: 'grysbh'},
        {title: '咨询流程', id: 'six'},
        {title: '合作医院', id: 'five'},
        {title: '服务案例', id: 'cases'},
      ]
    }
  },
  components: {
    leftSideBar,
    SideBar
  },
  mounted() {
    this.getHospitalList();
    this.getSuccessList();
  },
  methods: {
    async getHospitalList() {
      try {
        let data = {
          hospital_type_id: 4,
          //抗衰老 6
          state_id: undefined,
          area_id: undefined,
          department_id: undefined,
          disease_id: [],
          keyword: undefined,
          page: 1
        }
        let res = await apis.getAllHospitalList(data);
        if (res.code == 200) {
          // console.log(res.data.data)
          let rs = res.data.data.map(item => {
            return {
              ...item,
              info: this.getSimpleText(item.easy_brief)
            }
          });
          if (rs.length > 6) {
            this.hospitals = rs.slice(0, 6);
          } else {
            this.hospitals = rs;
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    getSimpleText(html) {
      var re1 = new RegExp("<.+?>", "g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, '');//执行替换成空字符
      return msg;
    },
    async getSuccessList() {
      try {
        let data = {
          page: 1,
          id: 0,
          disease_id: 0,
          type_id: 4
        }
        let res = await cases.getSuccessCaseList(data);
        if (res.code == 200) {
          this.cases = res.data.data.slice(0, 3);
        }
      } catch (e) {
        console.log(e)
      }
    },
    setDoctorName(name) {
      if (name) {
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
.ccc:hover {
  color: #2d8cf0 !important;
}

.bg-white {
  background: #fff;
  border-top: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
}

.secure-block {
  width: 980px;
  border: 1px solid #dcdcdc;
  background: #fff;
  padding: 30px;
  margin: 20px auto 50px;
}

.secure-title {
  font-size: 24px;
  color: #000;
  line-height: 28px;
  padding-left: 40px;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 28px auto;
  margin-bottom: 45px;

  a {
    float: right;
    // font-size: 14px;
    color: #333130;
  }
}

.title01 {
  // background-image: url('../assets/images/home/yy-icon.png');
  padding-top: 107px;
  background: url('../assets/images/home/hzyy-icon.png') no-repeat 0 107px;
  background-size: 28px 28px;
}

.title02 {
  background-image: url('../assets/images/home/fwal-icon.png');
  background-position: 0 70px;
  background-size: 28px 28px;
}

.secure-reason {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.secure-note {
  font-size: 16px;
  color: #000;
  width: 591px;
  line-height: 32px;
}

.secure-specials {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 72px;

  p {
    width: 234px;
    height: 65px;
    background: #ae1e10;
    color: #fff;
    font-size: 24px;
    line-height: 65px;
    text-align: center;
  }
}

.secure-hospital {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 32px;

  a {
    display: block;
    width: 302px;
    min-height: 396px;
    background: #fff;
    border: 1px solid #dcdcdc;
    margin-bottom: 32px;
    margin-right: 37px;

    &:nth-child(3n + 3) {
      margin-right: 0;
    }
  }

  .hospital-img {
    width: 300px;
    height: 220px;
    margin-bottom: 25px;
  }

  .hospital-name {
    min-height: 47px;
    font-size: 18px;
    color: #333130;
    line-height: 24px;
    margin-bottom: 15px;
    padding: 0 10px;
  }

  .hospital-info {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    color: #9b9898;
    font-size: 16px;
    line-height: 28px;
    padding: 0 10px;
  }
}

.qualify {
  padding: 50px 0 60px;
}

.qualify-title {
  font-size: 24px;
  color: #000;
  text-align: center;
  margin: 40px 0;
}

.secure-zizhi {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 66px;

  .qualifications {
    img {
      width: 163px;
      height: 226px;
      margin-bottom: 35px;
    }

    p {
      font-size: 16px;
      color: #ae1e10;
      line-height: 20px;
      text-align: center;
    }
  }
}

.user-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .secure-user {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 110px;
    border: 1px solid #dcdcdc;
    background: #fff;

    img {
      width: 60px;
      height: 60px;
      margin-right: 18px;
    }

    p {
      font-size: 28px;
      color: #ae1e10;
    }
  }
}

.group-list {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  li {
    width: 300px;
    list-style: disc;
    list-style-position: inside;
    color: #333;
    font-size: 16px;
    line-height: 30px;
    text-decoration: none;
    text-indent: 50px;
  }
}

.special-title {
  position: relative;
  background: #e9ebf4;
  height: 50px;
  font-size: 18px;
  line-height: 50px;
  padding-left: 93px;
  overflow: hidden;
  margin-bottom: 40px;
  color: #333333;
  font-weight: normal;

  span {
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 84px;
    background: #ae1e10;
    color: #fff;
    text-align: center;
  }
}

.medicine-case {
  width: 100%;
  border: 1px solid #ececec;
  padding: 34px 54px 34px 27px;
  // margin-bottom: 10px;
  .case-img {
    width: 237px;
    height: 177px;
    margin-right: 34px;
  }

  .case-info_text {
    width: 500px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .case-info {
    display: block;
    // width: 610px;
    // vertical-align: top;
    h5 {
      font-size: 20px;
      color: #373737;
      font-weight: normal;
      line-height: 26px;
      margin-bottom: 10px;

      p {
        display: inline-block;
        font-size: 16px;
      }
    }

    .case-ill {
      font-size: 18px;
      color: #cf1300;
      line-height: 22px;
      // background: url("../assets/images/medicine/line.jpg") repeat-x bottom;
      // padding-bottom: 16px;
      // margin-bottom: 18px;
    }

    .case-topic {
      font-size: 14px;
      color: #585858;
      line-height: 30px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}

.container-img-text {
  display: flex;
  justify-content: space-between;
  margin-bottom: 100px;
}

.container-img-text img {
  width: 281px;
  height: 181px;
}

.medicine-case .case-info .case-ill .b {
  color: #333;
}

.content_class {
  text-align: justify;
  -ms-text-align-last: justify;
  -moz-text-align-last: justify;
  text-align-last: start;
  word-break: break-all;
  text-justify: distribute;
}
</style>
